export default "__VITE_ASSET__DaV2XS$W__"